module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'zlaiw7u7',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
